/* eslint-disable */
// Code generated by scripts/generate-scada-fonts.js. DO NOT EDIT.
export const SCADA_CUSTOM_FONT_OPTIONS = Object.freeze([
  {
    "family": "7 Segment",
    "style": "Regular",
    "file": "7 Segment.ttf",
    "hash": "4f4d63fb100d",
    "value": "SCADA-7-Segment-Regular",
    "label": "7 Segment — Regular",
    "legacyValues": [
      "7 Segment — Regular",
      "SCADA 7 Segment — Regular"
    ],
    "url": "/scada-fonts/7%20Segment.ttf?v=4f4d63fb100d"
  },
  {
    "family": "Comfortaa",
    "style": "Bold",
    "file": "Comfortaa_Bold.ttf",
    "hash": "29331bdc3b8f",
    "value": "Comfortaa — Bold",
    "label": "Comfortaa — Bold",
    "legacyValues": [],
    "url": "/scada-fonts/Comfortaa_Bold.ttf?v=29331bdc3b8f"
  },
  {
    "family": "Comfortaa",
    "style": "Regular",
    "file": "Comfortaa_Regular.ttf",
    "hash": "4327cef08f19",
    "value": "Comfortaa — Regular",
    "label": "Comfortaa — Regular",
    "legacyValues": [],
    "url": "/scada-fonts/Comfortaa_Regular.ttf?v=4327cef08f19"
  },
  {
    "family": "Comfortaa",
    "style": "Thin",
    "file": "Comfortaa_Thin.ttf",
    "hash": "f89bf2ce6e5c",
    "value": "Comfortaa — Thin",
    "label": "Comfortaa — Thin",
    "legacyValues": [],
    "url": "/scada-fonts/Comfortaa_Thin.ttf?v=f89bf2ce6e5c"
  },
  {
    "family": "Digital-7",
    "style": "Italic",
    "file": "digital-7 (italic).ttf",
    "hash": "8d78fcd8690b",
    "value": "Digital-7 — Italic",
    "label": "Digital-7 — Italic",
    "legacyValues": [],
    "url": "/scada-fonts/digital-7%20(italic).ttf?v=8d78fcd8690b"
  },
  {
    "family": "Digital-7",
    "style": "Mono",
    "file": "digital-7 (mono).ttf",
    "hash": "7c6663d89617",
    "value": "Digital-7 — Mono",
    "label": "Digital-7 — Mono",
    "legacyValues": [],
    "url": "/scada-fonts/digital-7%20(mono).ttf?v=7c6663d89617"
  },
  {
    "family": "Digital-7",
    "style": "Regular",
    "file": "digital-7.ttf",
    "hash": "632d3c7fe9ca",
    "value": "Digital-7 — Regular",
    "label": "Digital-7 — Regular",
    "legacyValues": [],
    "url": "/scada-fonts/digital-7.ttf?v=632d3c7fe9ca"
  },
  {
    "family": "DS-Digital",
    "style": "Bold Italic",
    "file": "DS-DIGIT (Bold).TTF",
    "hash": "4d330a549ac9",
    "value": "DS-Digital — Bold Italic",
    "label": "DS-Digital — Bold Italic",
    "legacyValues": [],
    "url": "/scada-fonts/DS-DIGIT%20(Bold).TTF?v=4d330a549ac9"
  },
  {
    "family": "DS-Digital",
    "style": "Italic",
    "file": "DS-DIGI(Italic).TTF",
    "hash": "7402d9353299",
    "value": "DS-Digital — Italic",
    "label": "DS-Digital — Italic",
    "legacyValues": [],
    "url": "/scada-fonts/DS-DIGI(Italic).TTF?v=7402d9353299"
  },
  {
    "family": "DS-Digital",
    "style": "Normal",
    "file": "DS-DIGI.TTF",
    "hash": "87eb14d41eee",
    "value": "DS-Digital — Normal",
    "label": "DS-Digital — Normal",
    "legacyValues": [],
    "url": "/scada-fonts/DS-DIGI.TTF?v=87eb14d41eee"
  },
  {
    "family": "RR Beaver",
    "style": "Regular",
    "file": "BEAVER_0.TTF.TTF",
    "hash": "ae70dbc3fab3",
    "value": "RR Beaver — Regular",
    "label": "RR Beaver — Regular",
    "legacyValues": [],
    "url": "/scada-fonts/BEAVER_0.TTF.TTF?v=ae70dbc3fab3"
  },
  {
    "family": "SerpentineDBol",
    "style": "Regular",
    "file": "SerpentineDBol.ttf",
    "hash": "86fa6370c5f2",
    "value": "SerpentineDBol — Regular",
    "label": "SerpentineDBol — Regular",
    "legacyValues": [],
    "url": "/scada-fonts/SerpentineDBol.ttf?v=86fa6370c5f2"
  },
  {
    "family": "VNI-Cooper",
    "style": "Heavy",
    "file": "12_5990_VCOOPERB.TTF",
    "hash": "fd8503d6ba41",
    "value": "VNI-Cooper — Heavy",
    "label": "VNI-Cooper — Heavy",
    "legacyValues": [],
    "url": "/scada-fonts/12_5990_VCOOPERB.TTF?v=fd8503d6ba41"
  }
]);
